module.exports = __webpack_public_path__ + "static/media/Inspiringcompany.56b6104b.svg";